import './index.css';
import * as React from 'react';
import { forwardRef } from 'react';
import { RefType, ButtonProps } from '@/components/common/Button/types';

const buttonType = {
	"primary": "btn-primary",
	"tertierry": "btn-tertierry"
}

const buttonSize = {
	"regular": "btn-regular",
	"sm": "btn-sm"
}

const Button = forwardRef<RefType, ButtonProps>(
	(
		{
			children,
			type = 'button',
			className,
			variant = 'primary',
			size = 'regular',
			pill,
			disabled = false,
			onClick,
			form,
			...props
		} : ButtonProps, ref
	) => (
		<button
			ref={ref}
			disabled={disabled}
			type={type}
			className={`btn ${buttonType[variant]} ${buttonSize[size]} ${className}`}
			form={form}
			onClick={(e) => {
				onClick(e)
			}}
			{...props}
		>
			{children}
		</button>
	)
)

export default Button
